import React from "react";
import PropTypes from "prop-types";
import { ChartSeries, ChartSeriesItem } from "@progress/kendo-react-charts";

/**
 * ChartSeriesComponent
 * @class
 * @property {array} seriesItemProps - Props of module ChartSeriesItem in array
 */

/**
 * ChartSeries
 * @module
 */

/**
 * ChartSeriesItem
 * @module
 * @property {array} data - Data
 * @property {number} gap - Gap
 * @property {string} name - Name
 * @property {number} spacing - Spacing
 * @property {string} type - Type
 * @property {string} axis - Axis
 */

const ChartSeriesComponent = (props) => {
  const { seriesItemProps } = props;
  return (
    <ChartSeries>
      {seriesItemProps.map((props, key) => {
        return (
          <ChartSeriesItem
            key={key}
            data={props.data}
            gap={props.gap}
            name={props.name}
            spacing={props.spacing}
            type={props.type}
            axis={props.axis}
          />
        );
      })}
    </ChartSeries>
  );
};

ChartSeriesComponent.propTypes = {
  seriesItemProps: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.array,
      gap: PropTypes.number,
      name: PropTypes.string,
      spacing: PropTypes.number,
      type: PropTypes.string,
      axis: PropTypes.string,
    })
  ),
};

export default ChartSeriesComponent;
